export type NavItem = { href: string; label: string; icon: string };

// Module in der Reihenfolge des Mockups (docs/mockups/Sidebar.dc.html). Icons: SVG-Pfade 24×24
export const MODULES: NavItem[] = [
  { href: "/", label: "Übersicht", icon: "M3 3h7v9H3zM14 3h7v5h-7zM14 12h7v9h-7zM3 16h7v5H3z" },
  { href: "/briefing", label: "Briefing", icon: "M6 2h9l5 5v15H6zM14 2v6h6M9 13h8M9 17h6" },
  { href: "/onpage", label: "Onpage-Optimierung", icon: "M4 4h16v16H4zM8 9h8M8 13h8M8 17h5" },
  { href: "/prompts", label: "Prompts", icon: "M4 5h16v11H9l-5 4z" },
  { href: "/audit", label: "Site Audit", icon: "M11 4a7 7 0 1 0 0 14a7 7 0 0 0 0-14zM16 16l5 5" },
  {
    href: "/wettbewerb",
    label: "Wettbewerber",
    icon: "M12 3a3 3 0 1 0 0 6a3 3 0 0 0 0-6zM5 15a3 3 0 1 0 0 6a3 3 0 0 0 0-6zM19 15a3 3 0 1 0 0 6a3 3 0 0 0 0-6zM12 9v3M7 15l3-3M17 15l-3-3",
  },
  { href: "/llm-analyse", label: "LLM-Analyse", icon: "M4 19V9M10 19V5M16 19v-7M22 19H2M18 5l3 3-3 3" },
  { href: "/monitoring", label: "Monitoring", icon: "M3 12h4l3-8l4 16l3-8h4" },
  {
    href: "/links",
    label: "Interne Links",
    icon: "M10 14a4 4 0 0 0 6 0l3-3a4 4 0 0 0-6-6l-1 1M14 10a4 4 0 0 0-6 0l-3 3a4 4 0 0 0 6 6l1-1",
  },
  { href: "/kosten", label: "Kosten", icon: "M12 3v18M16 7.5C16 6 14.2 5 12 5s-4 1-4 2.5S9.8 10 12 10s4 1 4 2.5S14.2 15 12 15s-4-1-4-2.5" },
];

export const SETTINGS: { href: string; label: string }[] = [
  { href: "/settings/connections", label: "Verbindungen verwalten" },
  { href: "/settings/briefing", label: "Briefing-Einstellungen" },
];

/** Aktiv ist der Punkt, dessen Pfad der aktuelle ist oder davor liegt. `/` zählt nur für sich. */
export function isActive(href: string, pathname: string): boolean {
  if (href === "/") return pathname === "/";
  return pathname === href || pathname.startsWith(`${href}/`);
}
